import { SitePage } from './SiteChrome';
import { Mark } from '@/brand/Mark';
import { useI18n } from '@/lib/i18n';
import { ButtonLink } from '@/ui';
import './pages.css';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <SitePage>
      <div className="site-shell notfound">
        <div className="notfound-inner">
          <Mark size={56} animate />
          <h1 className="section-title">{t.errors.notFound}</h1>
          <p className="lead">{t.errors.notFoundLead}</p>
          <div className="row">
            <ButtonLink to="/" variant="secondary">{t.errors.backSite}</ButtonLink>
            <ButtonLink to="/app" variant="primary">{t.errors.backHome}</ButtonLink>
          </div>
        </div>
      </div>
    </SitePage>
  );
}
